package com.sweetlime.bingeamigo.presentation.components

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import com.sweetlime.bingeamigo.presentation.ui.BrandColors
import androidx.compose.ui.unit.dp
import com.sweetlime.bingeamigo.model.UserProfile

@Composable
fun FollowUserCard(
    user: UserProfile,
    openUserProfile: (userId: String) -> Unit
) {

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp, vertical = 6.dp)
            .clip(RoundedCornerShape(18.dp))
            .background(BrandColors.Card)
            .border(1.dp, Color(0xFF2A2A2E), RoundedCornerShape(18.dp))
            .clickable { openUserProfile(user.id) }
            .padding(16.dp),
        verticalAlignment =
            Alignment.CenterVertically
    ) {

        Box(
            modifier = Modifier
                .size(54.dp)
                .clip(CircleShape)
                .background(BrandColors.Secondary),
            contentAlignment =
                Alignment.Center
        ) {

            Text(
                text = user.username
                    .take(1)
                    .uppercase(),
                color = Color.White,
                fontWeight = FontWeight.Bold
            )
        }

        Spacer(modifier = Modifier.width(14.dp))

        Column {

            Text(
                text = user.username,
                color = Color.White,
                fontWeight = FontWeight.Bold
            )

            Text(
                text = "Level ${user.level}",
                color = Color.Gray
            )
        }
    }
}